import type { FlagStore } from '@platform/feature-flags';

export const HUB_PREFIX = '/_hub';

/**
 * The same build is served at `/` (direct origin) and `/_hub` (via the web-proxy,
 * which strips the prefix server-side). The client router still sees `/_hub/...`,
 * so it needs a matching basepath or deep-links/reloads under `/_hub` 404. Derive
 * it from the live pathname so one build works at both mounts.
 */
export function resolveBasepath(pathname: string = typeof window !== 'undefined' ? window.location.pathname : '/'): string | undefined {
  return pathname === HUB_PREFIX || pathname.startsWith(`${HUB_PREFIX}/`) ? HUB_PREFIX : undefined;
}

/**
 * Kill-switch flag for the `/_hub` escape hatch: default-on, disabled only when
 * explicitly `false`, so prod can turn it off without an nginx change.
 */
export const HUB_ESCAPE_HATCH_FLAG = 'hub-escape-hatch';

export function isHubMountAllowed(featureFlags: Pick<FlagStore, 'getFlag'> | undefined, pathname?: string): boolean {
  if (resolveBasepath(pathname) !== HUB_PREFIX) {
    return true;
  }
  return featureFlags?.getFlag(HUB_ESCAPE_HATCH_FLAG) !== false;
}
